var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-2"},[_c('div',{staticClass:"semi-6100 -m-4"},[_c('admin-crop-grid',{attrs:{"rows":_vm.allPriceIndications,"cols":_vm.cols,"defaultOrderBy":null,"should-paginate":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }